<template>
  <div
      class="warehouse-order-article -entity"
      :class="{ '-done': isDone, '-deleted': isDeleted, '-is-complete': isComplete }"
  >
    <div class="warehouse-order-article_description">
      <div class="image">
        <!--        {{ data.id }} ##-->
      </div>
      <div class="text">
        {{ data.name }}
      </div>
    </div>

    <div class="warehouse-order-article_unit"></div>

    <v-tooltip bottom nudge-top="38">
      <template v-slot:activator="{ on, attrs }">
        <div class="warehouse-order-article_demand" :data-mobile-label="$t('sl.warehouse.headers.demand')"
             v-bind="attrs"
             v-on="on"
        >
          <div>
          <span>
            {{ demand }} / {{ totalPicked }}
          </span>
          </div>
        </div>
      </template>
      <span>{{ demand }} bestellt / {{ totalPicked }} geliefert</span>
    </v-tooltip>

    <v-tooltip bottom nudge-top="38">
      <template v-slot:activator="{ on, attrs }">
        <div class="warehouse-order-article_due" :data-mobile-label="$t('sl.warehouse.headers.due')"
             v-bind="attrs"
             v-on="on"
        >
          <div>
              <span :class="pickedQuantity > 0? 'text--primary': ''">
                {{ totalDue }}
              </span>
          </div>
        </div>
      </template>
      <span>{{ totalDue }} Offen</span>
    </v-tooltip>

    <div class="warehouse-order-article_spacer">

    </div>

    <div class="warehouse-order-article_picked" :data-mobile-label="$t('sl.warehouse.headers.picked')">
      <div v-if="isComplete">
        <template v-if="isDeleted">
          <span v-if="totalPicked > 0">{{ totalPicked }}</span>
        </template>
        <template v-else>
          {{ demand }}
        </template>
      </div>
      <v-text-field
          v-else-if="!isDone && !isDeleted"
          v-model="pickedQuantity"
          type="number"
          min="0"
          :max="(demand - totalPicked)"
          light
          autocomplete="off"
          class="float-right number-input black-input-color"
          :class="pickedQuantity > 0? 'input-text-primary': 'input-text-black'"
          style="width: 70px;margin-right: -10px;"
          :disabled="disabled || isComplete || isUpdating"
          @input="onInput"
          @blur="update(pickedQuantity)"
      />
    </div>

    <div class="warehouse-order-article_completed" :data-mobile-label="$t('sl.warehouse.headers.completed')">
      <template v-if="isDone || isComplete">
        <div
            v-if="!isDeleted || (demand - totalPicked === 0)"
            class="isDone pr-3 icon-haekchen"
        ></div>
      </template>
      <div v-else-if="isDeleted"></div>
      <v-checkbox
          v-else
          v-model="completeItem"
          :disabled="disabled || isUpdating"
      />
    </div>

    <div class="warehouse-order-article_delete" :data-mobile-label="$t('sl.warehouse.headers.delete')">

    </div>
  </div>
</template>

<script>
import ArticleImage from "@/components/SmartLogistics/Article/ArticleImage.vue";
import ArticleCaption from "@/components/SmartLogistics/Article/ArticleCaption.vue";
import {internalOrderMixin} from "@/mixins/SmartLogistics/ModelC/internalOrder";
import QuantityInput from "@/components/shared/QuantityInput.vue";

export default {
  name: 'EntityArticle',
  components: {QuantityInput, ArticleCaption, ArticleImage},
  mixins: [internalOrderMixin],

  props: {
    data: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isComplete: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      pickedQuantity: 0,
    }
  },

  computed: {
    isLivingUnit() {
      return this.data.id.toString().startsWith('lu_')
    },

    hasNoPartialDelivery() {
      return this.order.status === 'new'
    },

    artikelNrLAG() {
      return this.data.artikelNrLAG
    },

    entityType() {
      return this.isLivingUnit ? 'living-unit' : 'resident'
    },

    entityId() {
      return this.data.id.toString().replace('lu_', '')
    },

    totalPicked() {
      return +this.currentlyPicked.deliveredBefore
    },

    demand() {
      return +this.data.quantity
    },


    totalDue() {
      return this.demand - this.totalPicked - this.pickedQuantity
    },

    entityPosition() {
      return this.currentlyOpenPartialDelivery.items.findIndex(i =>
          i.artikelNrLAG == this.artikelNrLAG &&
          i.ownerType === this.entityType &&
          i.ownerId == this.entityId)
    },

    currentlyPicked() {
      return this.currentlyPickedFor(this.artikelNrLAG, this.entityType, this.entityId)
    },

    isCompleted() {
      if (this.isComplete) return true

      return this.currentlyPicked.orderedQuantity <= this.currentlyPicked.deliveredBefore + this.pickedQuantity
    },

    isDone() {
      return this.currentlyPicked.orderedQuantity === this.currentlyPicked.deliveredBefore
    },

    isDeleted() {
      return !!this.currentlyPicked.deleted;
    },

    completeItem: {
      get() {
        return this.isCompleted
      },
      set(value) {
        if (value) {
          this.pickedQuantity = this.currentlyPicked.orderedQuantity - this.currentlyPicked.deliveredBefore
        } else {
          this.pickedQuantity = 0
        }

        this.update(this.pickedQuantity)
      }

    }
  },

  methods: {
    onInput(value) {
      this.pickedQuantity = +value
    },

    update(value) {
      let openDemand = (this.demand - this.totalPicked);
      if (value > openDemand) {
        value = openDemand
        this.pickedQuantity = openDemand
      }

      this.$store.dispatch('smartLogisticWarehouse/updateItem', {
        partialDeliveryId: this.currentlyOpenPartialDelivery.id,
        item: {
          artikelNrLAG: this.artikelNrLAG,
          ownerType: this.entityType,
          ownerId: this.entityId,
          quantity: +value
        }
      })
    }
  },

  watch: {
    currentlyPicked() {
      this.pickedQuantity = +this.currentlyPicked.quantity
    },
  },

  mounted() {
    this.pickedQuantity = +this.currentlyPicked.quantity
  }
}
</script>


<style lang="scss">
.v-input.input-text-primary input {
  color: #CE20A8;
}
</style>